
import React, { Component } from 'react'
import CreateStatus from './CreateStatus'
import ViewStatus from './ViewStatus'
import setTitle from "../../../helpers/TitleComponent";
import { getCookie, getAccessToken } from "../../../helpers/cookieHelper";
import { API_URL } from '../../../constants';
import { Messager } from 'rc-easyui';



const axios = require("axios");
export default class Status extends Component {
    constructor() {
        super()
        this.childRef = React.createRef()
        this.state = {
            sta: {
                status: "",
            },
            StatusList: [],
            rules: {
                status: ['required'],
            },
            operation: "Add",
            selected: {},
            permissions: [],
        }

    }
    componentDidMount = () => {
        var data = getCookie('permission');
        this.setState({
            permissions: JSON.parse(data),
        },


            function () {
                setTitle('Priority Entry')

                this.getTicketStatusId()
            }
        );
    }



    handleInput = (name, value) => {

        const newArr = { ...this.state.sta }
        newArr[name] = value
        this.setState({
            sta: newArr

        })

    }
    // formClear=()=> {
    //     let clearTicket = {
    //          priority:""
    //     };
    //     this.setState({
    //         prioirty: clearTicket,
    //         operation: "Add",
    //       },
    //       function () {
    //            this.childRef.current.validate((errors) => {});
    //                   }
    //               );
    //   }
    OnEditClick = (row) => {
        var rules = this.state.rules;
        console.log(this.state.selected);
        // if (this.state.selected != null) {

        this.setState({
            sta: row,
            rules: rules,
            priority: this.state.selected,
            operation: "Update",
        });

        const timer = setTimeout(() => {
            this.childRef.current.validate((errors) => { });
        }, 100);
        return () => clearTimeout(timer);
        // }
    }
    onSelectionChange = (selectedRow) => {
        console.log(selectedRow)
        this.setState({
            selected: selectedRow,
        });
    }

    getTicketStatusId = async () => {
        let access_token = getCookie('access_token')
        let token_type = getCookie('token_type')
        let headerConfig = {
            headers: {
                authorization: token_type + ' ' + access_token,
                'Content-Type': 'application/json',
            },
        }
        if (access_token !== null) {
            axios.get(API_URL + 'api/fetchallticketstatustype', headerConfig)
                .then((response) => {

                    if (response.status === 200) {

                        let dataObject = response.data.object
                        this.setState({
                            StatusList: dataObject
                        })
                    } else {
                        this.setState({
                            StatusList: [],
                        })
                    }
                })
                .catch((error) => {
                    //console.log(error)
                    this.setState({
                        StatusList: [],
                    })
                    //alert("Internal server error")l
                    let response = error['response']
                    if (response !== undefined) {
                        if (response.data.status === 403) {
                            this.messager.alert({
                                title: 'Error',
                                icon: 'error',
                                reload: false,
                                msg: response.data.message,
                            }) //Backend Validation Error i.e. 403
                        } else {
                            this.messager.alert({
                                title: 'Error',
                                msg: 'UnCaught Error',
                                icon: 'error',
                                reload: false,
                            })//uncaught Backend Error i.e. 500
                        }
                    } else {
                        this.messager.alert({
                            title: 'Error',
                            icon: 'error',
                            msg: 'Internal Server Error',
                            reload: false
                        })// caused due to syntax error in front end
                    }
                })
        } else {
            const resp = await getAccessToken()
            if (resp) {
                this.getTicketStatusId()
            }
        }
    }

    render() {

        return (
            <div>
                <Messager ref={ref => this.messager = ref}></Messager>

                <div className='container-fluid'>
                    <div className='row'>
                        <div className='col-4'>


                            <CreateStatus
                                sta={this.state.sta}
                                handleInput={this.handleInput}
                                operation={this.state.operation}
                                rules={this.state.rules}
                                ref={this.childRef}
                                formClear={this.formClear}
                            />
                        </div>
                        <div className='col-8'>
                            <ViewStatus

                                OnEditClick={this.OnEditClick}
                                onSelectionChange={this.onSelectionChange}
                                selectedRow={this.state.selected}

                                permissions={this.state.permissions}

                            />
                        </div>

                    </div>
                </div>

            </div>
        )
    }
}
